
import { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Mail, MessageSquare, Shield } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const SocialLogin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { googleLogin } = useAuth();

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      setIsLoading(true);
      await googleLogin(codeResponse.code);
      setIsLoading(false);
    },
    onError: () => {
      console.error("Google login failed");
    },
    flow: "auth-code",
  });

  return (
    <div className="mt-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <Separator className="w-full" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-white text-gray-500">Or continue with</span>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-3">
        <Button
          type="button"
          variant="outline"
          onClick={() => handleGoogleLogin()}
          className="w-full flex items-center justify-center"
          disabled={isLoading}
        >
          <Mail className="h-5 w-5 mr-2" />
          <span>Google</span>
        </Button>

        <Button
          type="button"
          variant="outline"
          onClick={() => {}}
          className="w-full flex items-center justify-center"
          disabled={true}
        >
          <MessageSquare className="h-5 w-5 mr-2" />
          <span>Facebook</span>
        </Button>
      </div>

      <div className="mt-6 pt-4 border-t border-gray-200">
        <div className="flex items-center">
          <Shield className="h-5 w-5 text-gray-400 mr-2" />
          <p className="text-xs text-gray-500">
            Your data is protected with enterprise-grade security. We never share your information without permission.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SocialLogin;
